export enum DaySectionDataHooks {
  Slot = 'daily-agenda-slot',
  DayDate = 'daily-agenda-day-date',
}
